import styled from '@emotion/styled';

export const CardLoanRequestWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.lg};
  padding: ${({theme}) => theme.padding.desktop.md};
`;
